<!--
 * @Author: 王时霞
 * @Date: 2024-01-18 08:55:25
 * @LastEditors: 王时霞
 * @LastEditTime: 2026-06-25 15:22:24
 * @Description: file content
 * @FilePath: \yuyue.keenkq.com\src\views\wx_work\components\SelectItem.vue
-->
<template>
  <div>
    <van-field 
      v-model="value" 
      :label="label" 
      :placeholder="`请选择${label}`"
      @click="show = true" 
      :rules="required?[{ required: true, message: `请选择${label}` }]:[]"
      :required="required"
      readonly 
      is-link
    />
    <van-action-sheet v-model="show" :actions="options" @select="onSelect" />
  </div>
</template>
<script>
export default {
  props:{
    options:Array,
    label:String,
    value:String,
    required:Boolean,
  },
  data() {
    return {
      show:false,
    };
  },
  methods:{
    onSelect(item){
      console.log(item)
      this.show = false
      this.$emit('onSelect',item)
    }
  }
};
</script>
<style>
.no-style{
  padding:0px;
  margin:0px;
}
</style>


